/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "inlineStyles", "testId", "isRanking", "innerRef", "isSortable", "sortOrder", "onClick", "headCellId", "activeSortButtonId", "ascendingSortTooltip", "descendingSortTooltip", "buttonAriaRoleDescription", "isIconOnlyHeader"];
import "./table-head-cell.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useCallback, useState } from 'react';
import ArrowDownIcon from '@atlaskit/icon/core/arrow-down';
import ArrowUpIcon from '@atlaskit/icon/core/arrow-up';
import { Box, Flex, Pressable, Text } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip';
import { ASC } from '../internal/constants';
import { HeadCell } from '../styled/table-head';
var styles = {
  buttonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
  sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
  sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
  hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
  visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
var headCellStyles = {
  headCellContainer: "_1e0c1txw _4cvr1h6o"
};
var TableHeadCell = function TableHeadCell(_ref) {
  var content = _ref.content,
    inlineStyles = _ref.inlineStyles,
    testId = _ref.testId,
    isRanking = _ref.isRanking,
    innerRef = _ref.innerRef,
    isSortable = _ref.isSortable,
    sortOrder = _ref.sortOrder,
    onClick = _ref.onClick,
    headCellId = _ref.headCellId,
    activeSortButtonId = _ref.activeSortButtonId,
    _ref$ascendingSortToo = _ref.ascendingSortTooltip,
    ascendingSortTooltip = _ref$ascendingSortToo === void 0 ? 'Sort ascending' : _ref$ascendingSortToo,
    _ref$descendingSortTo = _ref.descendingSortTooltip,
    descendingSortTooltip = _ref$descendingSortTo === void 0 ? 'Sort descending' : _ref$descendingSortTo,
    _ref$buttonAriaRoleDe = _ref.buttonAriaRoleDescription,
    buttonAriaRoleDescription = _ref$buttonAriaRoleDe === void 0 ? 'Sort button' : _ref$buttonAriaRoleDe,
    isIconOnlyHeader = _ref.isIconOnlyHeader,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
  var isSortIconVisible = isHovered || isActive || isFocused;
  var isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
  var shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
  var handleFocus = useCallback(function () {
    setIsFocused === null || setIsFocused === void 0 || setIsFocused(true);
  }, [setIsFocused]);
  var handleBlur = useCallback(function () {
    setIsFocused === null || setIsFocused === void 0 || setIsFocused(false);
  }, [setIsFocused]);
  var handleMouseEnter = useCallback(function () {
    setIsHovered(true);
  }, [setIsHovered]);
  var handleMouseLeave = useCallback(function () {
    setIsHovered(false);
  }, [setIsHovered]);
  var visuallyRefreshedButton = /*#__PURE__*/React.createElement(Box, {
    xcss: headCellStyles.headCellContainer,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onFocus: handleFocus,
    onBlur: handleBlur
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: sortOrder === ASC ? ascendingSortTooltip : descendingSortTooltip
  }, /*#__PURE__*/React.createElement(Pressable, {
    onClick: onClick,
    xcss: styles.buttonWrapper,
    "aria-roledescription": buttonAriaRoleDescription
  }, /*#__PURE__*/React.createElement(Flex, {
    xcss: isVisibleIconOnlyHeader ? styles.hideIconHeaderWrapper : styles.visibleHeaderWrapper
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "color.text.subtle",
    weight: "bold",
    maxLines: 1
  }, content)), shouldRenderSortIcon && /*#__PURE__*/React.createElement(Flex, {
    xcss: isSortIconVisible ? styles.sortIconVisibleWrapper : styles.sortIconHiddenWrapper
  }, sortOrder === ASC ? /*#__PURE__*/React.createElement(ArrowUpIcon, {
    label: "",
    color: "var(--ds-text-subtle, #44546F)",
    testId: testId && "".concat(testId, "--up--icon")
  }) : /*#__PURE__*/React.createElement(ArrowDownIcon, {
    label: "",
    color: "var(--ds-text-subtle, #44546F)",
    testId: testId && "".concat(testId, "--down--icon")
  })))));
  return /*#__PURE__*/React.createElement(HeadCell
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
  , _extends({
    style: inlineStyles,
    testId: testId && "".concat(testId, "--head--cell"),
    ref: typeof innerRef !== 'string' ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, rest, {
    isSortable: isSortable,
    sortOrder: sortOrder
  }), isSortable ? visuallyRefreshedButton : content);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default TableHeadCell;